import { render } from "./list.vue?vue&type=template&id=3184660e&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=3184660e&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3184660e"]])

export default __exports__